import { observer } from 'mobx-react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Typography from '@mui/material/Typography'
import smavaIllustration from 'assets/icons/voucher-money-smava-full.png'
import VoucherBenefits from 'components/VoucherBanner/components/VoucherBenefits'
import { VOUCHER_TERMS_URL } from 'components/VoucherBanner/VoucherBanner.constants'
import { useStores } from 'stores/utils/hooks/useStores'
import useRCEVoucherBanner from '../../../VoucherBanner/hooks/useRCEVoucherBanner'
import { trackTermsAndConditions } from '../../../VoucherBanner/helpers/trackTermsAndConditions'
import {
  Card,
  ActivatedRow,
  ActivatedText,
  ActivateButton,
  Illustration
} from './RCEVariantCIncomeCard.styles'

const RCEVariantCIncomeCard = observer(() => {
  const {
    traversal: { data }
  } = useStores()
  const { presentation, isVoucherActivated, activateVoucher } =
    useRCEVoucherBanner()

  if (presentation.kind !== 'variant-c-edit') return null

  return (
    <Card aria-label="Gutschein aktivieren">
      <Illustration
        src={smavaIllustration}
        alt="Illustration für smava Gutschein"
        aria-hidden="true"
      />
      <Typography
        variant="overline"
        fontWeight={700}
        textTransform="uppercase"
        sx={{ color: 'rgba(228, 246, 230, 1)' }}
      >
        Jetzt bei smava
      </Typography>
      <VoucherBenefits
        amount={presentation.amount}
        providerName="smava.de"
        termsUrl={VOUCHER_TERMS_URL.smava}
        onTermsClick={() => trackTermsAndConditions(data)}
        variant="smava"
      />
      {isVoucherActivated ? (
        <ActivatedRow>
          <CheckCircleIcon fontSize="small" aria-hidden="true" />
          <ActivatedText variant="body1" fontWeight={700}>
            Ihr {presentation.amount} € Gutschein ist aktiviert!
          </ActivatedText>
        </ActivatedRow>
      ) : (
        <ActivateButton variant="contained" onClick={activateVoucher}>
          Gutschein aktivieren
        </ActivateButton>
      )}
    </Card>
  )
})

export default RCEVariantCIncomeCard
